<template>
    <basic-container>
        <avue-crud
            ref="crud"
            :option="option"
            :data="data"
            :page="page"
            :table-loading="loading"
            @on-load="onLoad"
            @search-reset="searchReset"
            @search-change="searchChange"
            @refresh-change="refreshChange">
            <template slot="status" slot-scope="scope">
                <el-tag :type="ticketStatusTag(scope.row.status)">{{ statusLabel(scope.row.status) }}</el-tag>
            </template>
            <template slot="urgency" slot-scope="scope">
                <el-tag :type="ticketUrgencyTag(scope.row.urgency)">{{ scope.row.urgency }}</el-tag>
            </template>
            <template slot="menu" slot-scope="scope">
                <el-button
                    type="text"
                    icon="el-icon-view"
                    @click="handleView(scope.row)">详情</el-button>
            </template>
        </avue-crud>

        <el-dialog
            title="客户信息反馈详情"
            :visible.sync="detailVisible"
            width="60%"
            append-to-body>
            <div class="detail-desc">
                <div class="desc-row">
                    <span class="desc-label">客户姓名</span>
                    <span class="desc-content">{{ detailForm.name }}</span>
                    <span class="desc-label">手机号</span>
                    <span class="desc-content">{{ detailForm.phone }}</span>
                </div>
                <div class="desc-row">
                    <span class="desc-label">是否匿名</span>
                    <span class="desc-content">{{ detailForm.anonymous ? '匿名' : '否' }}</span>
                    <span class="desc-label">紧急程度</span>
                    <span class="desc-content">
                        <el-tag :type="ticketUrgencyTag(detailForm.urgency)">{{ detailForm.urgency }}</el-tag>
                    </span>
                </div>
                <div class="desc-row">
                    <span class="desc-label">状态</span>
                    <span class="desc-content">
                        <el-tag :type="ticketStatusTag(detailForm.status)">{{ statusLabel(detailForm.status) }}</el-tag>
                    </span>
                    <span class="desc-label">创建时间</span>
                    <span class="desc-content">{{ formatTime(detailForm.createTime) }}</span>
                </div>
                <div class="desc-row">
                    <span class="desc-label">更新时间</span>
                    <span class="desc-content">{{ formatTime(detailForm.updateTime) }}</span>
                    <span class="desc-label">产品</span>
                    <span class="desc-content">{{ joinArrayField(detailForm.product) }}</span>
                </div>
                <div class="desc-row">
                    <span class="desc-label">问题分类</span>
                    <span class="desc-content">{{ joinArrayField(detailForm.category) }}</span>
                </div>
                <div class="desc-row">
                    <span class="desc-label">问题描述</span>
                    <span class="desc-content desc-block">{{ detailForm.detail }}</span>
                </div>
                <div class="desc-row">
                    <span class="desc-label">改进建议</span>
                    <span class="desc-content desc-block">{{ detailForm.suggestion }}</span>
                </div>
            </div>
            <div class="detail-section" v-if="detailForm.attachments && detailForm.attachments.length">
                <div class="section-title">附件</div>
                <div class="attach-list">
                    <div v-for="(f, i) in detailForm.attachments" :key="i" class="attach-item">
                        <img
                            v-if="isImage(f.name || f.url)"
                            :src="f.url"
                            class="attach-img"
                            @click="previewImg(f.url)" />
                        <a v-else :href="f.url" target="_blank" class="attach-link">{{ f.name }}</a>
                    </div>
                </div>
            </div>
            <div class="detail-section" v-if="detailForm.replies && detailForm.replies.length">
                <div class="section-title">回复记录</div>
                <div v-for="(r, i) in (detailForm.replies || [])" :key="'r' + i" class="reply-item">
                    <div class="reply-meta">
                        {{ r.replyUser || '用户补充' }} · {{ formatTime(r.createTime) }}
                    </div>
                    <div class="reply-content">{{ r.content }}</div>
                </div>
            </div>

            <div class="detail-section">
                <div class="section-title">处理操作</div>
                <div class="op-block">
                    <div class="op-row">
                        <span class="op-label">标记状态</span>
                        <el-select v-model="statusForm" placeholder="选择目标状态" style="width: 200px">
                            <el-option
                                v-for="s in TICKET_STATUS_DIC"
                                :key="s.value"
                                :label="s.label"
                                :value="s.value"></el-option>
                        </el-select>
                        <el-button
                            type="primary"
                            :loading="submitting"
                            @click="handleStatus">确定标记</el-button>
                    </div>
                    <div class="op-row">
                        <span class="op-label op-label-top">备注</span>
                        <el-input
                            type="textarea"
                            :rows="3"
                            v-model="remarkForm"
                            placeholder="管理员备注，对 H5 用户可见；保存后整体覆盖，留空即清空"
                            style="flex: 1"></el-input>
                    </div>
                    <div class="op-row op-row-end">
                        <el-button
                            type="primary"
                            :loading="submitting"
                            @click="handleRemark">保存备注</el-button>
                    </div>
                </div>
            </div>
        </el-dialog>
    </basic-container>
</template>

<script>
import { findTicketPage, updateTicketEdit } from '@/api/salesCloud/ticket';
import {
    ticketOption,
    TICKET_STATUS_DIC,
    ticketStatusTag,
    ticketUrgencyTag,
    formatTime,
    joinArrayField
} from '@/const/salesCloud/ticketOption';

const dicLabel = (dic, val) => {
    const item = dic.find(d => d.value === val);
    return item ? item.label : (val || '');
};

export default {
    name: 'TicketFeedback',
    data() {
        return {
            option: ticketOption,
            data: [],
            loading: false,
            page: {
                currentPage: 1,
                pageSize: 20,
                total: 0
            },
            query: {},
            detailVisible: false,
            detailForm: {},
            statusForm: '',
            remarkForm: '',
            submitting: false,
            TICKET_STATUS_DIC
        };
    },
    methods: {
        ticketStatusTag,
        ticketUrgencyTag,
        formatTime,
        joinArrayField,
        statusLabel(val) {
            return dicLabel(TICKET_STATUS_DIC, val);
        },
        onLoad(page) {
            this.page.currentPage = page.currentPage;
            this.page.pageSize = page.pageSize;
            this.getList();
        },
        searchReset() {
            this.query = {};
            this.page.currentPage = 1;
            this.getList();
        },
        searchChange(params) {
            this.query = params;
            this.page.currentPage = 1;
            this.getList();
        },
        refreshChange() {
            this.getList();
        },
        getList() {
            this.loading = true;
            const params = {
                ...this.query,
                page: this.page.currentPage,
                size: this.page.pageSize
            };
            findTicketPage(params)
                .then((res) => {
                    let resp = res.data;
                    if (typeof resp === 'string') {
                        resp = JSON.parse(resp);
                    }
                    const result = resp.data || resp;
                    const records = result.records || result.rows || [];
                    this.data = records;
                    this.page.total = result.total || 0;
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        handleView(row) {
            this.detailForm = row;
            this.statusForm = row.status || '';
            this.remarkForm = row.remark || '';
            this.detailVisible = true;
        },
        handleStatus() {
            if (!this.statusForm) {
                this.$message.warning('请选择目标状态');
                return;
            }
            if (this.statusForm === this.detailForm.status) {
                this.$message.info('状态未变更');
                return;
            }
            this.submitting = true;
            updateTicketEdit({ id: this.detailForm.id, status: this.statusForm })
                .then(() => {
                    this.$message.success('状态已标记');
                    this.submitting = false;
                    this.refreshDetail({ status: this.statusForm });
                })
                .catch(() => {
                    this.submitting = false;
                });
        },
        handleRemark() {
            this.submitting = true;
            updateTicketEdit({ id: this.detailForm.id, remark: this.remarkForm || '' })
                .then(() => {
                    this.$message.success('备注已保存');
                    this.submitting = false;
                    this.refreshDetail({ remark: this.remarkForm || '' });
                })
                .catch(() => {
                    this.submitting = false;
                });
        },
        refreshDetail(changed) {
            // 先同步更新内存中的行数据，立即可见（不依赖异步重新请求）
            const idx = this.data.findIndex(d => d.id === this.detailForm.id);
            if (idx > -1) {
                const row = { ...this.data[idx], ...changed };
                this.$set(this.data, idx, row);
                this.detailForm = row;
                this.statusForm = row.status || '';
                this.remarkForm = row.remark || '';
            } else {
                this.detailForm = { ...this.detailForm, ...changed };
                this.statusForm = this.detailForm.status || '';
                this.remarkForm = this.detailForm.remark || '';
            }
            // 重新拉取列表，保持与服务端一致（总数/排序等）
            this.getList();
        },
        isImage(name) {
            if (!name) return false;
            const ext = name.split('?')[0].split('.').pop().toLowerCase();
            return ['png', 'jpg', 'jpeg', 'gif', 'bmp', 'webp'].includes(ext);
        },
        previewImg(url) {
            window.open(url, '_blank');
        }
    }
};
</script>

<style scoped>
.detail-desc {
    border: 1px solid #ebeef5;
    border-radius: 4px;
    overflow: hidden;
    margin-bottom: 8px;
}
.desc-row {
    display: flex;
    border-bottom: 1px solid #ebeef5;
}
.desc-row:last-child {
    border-bottom: none;
}
.desc-label {
    width: 90px;
    flex: 0 0 90px;
    background: #fafafa;
    color: #606266;
    font-size: 13px;
    padding: 8px 10px;
    border-right: 1px solid #ebeef5;
    display: flex;
    align-items: center;
}
.desc-content {
    flex: 1;
    padding: 8px 10px;
    color: #303133;
    font-size: 13px;
    word-break: break-all;
    display: flex;
    align-items: center;
}
.desc-block {
    display: block;
}
.detail-section {
    margin-top: 16px;
}
.section-title {
    font-weight: 600;
    font-size: 14px;
    color: #303133;
    padding-left: 8px;
    border-left: 3px solid #409eff;
    margin-bottom: 10px;
}
.attach-list {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
}
.attach-item {
    color: #409eff;
}
.attach-img {
    width: 100px;
    height: 100px;
    object-fit: cover;
    border: 1px solid #ebeef5;
    border-radius: 4px;
    cursor: pointer;
}
.attach-link {
    color: #409eff;
    text-decoration: underline;
}
.reply-item {
    border-bottom: 1px solid #eee;
    padding: 8px 0;
}
.reply-meta {
    color: #999;
    font-size: 12px;
    margin-bottom: 4px;
}
.op-block {
    border: 1px solid #ebeef5;
    border-radius: 4px;
    padding: 12px;
}
.op-row {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
}
.op-row:last-child {
    margin-bottom: 0;
}
.op-row-end {
    justify-content: flex-end;
}
.op-label {
    width: 70px;
    flex: 0 0 70px;
    color: #606266;
    font-size: 13px;
}
.op-label-top {
    align-self: flex-start;
    padding-top: 8px;
}
</style>
